/**
 * Created by sswaminathan on 12/27/21
 * File: Validation
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { toNumber } from 'lodash'
import { ValidateSubDomainUrl } from '../../../common/actions/GlobalActions'
import { FF_SKIP_DOMAIN_VALIDATION } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import { URL_VALIDATIONS, URL_VALIDATIONS_REGEX, VALIDATION_SUCCESS } from '../constants/SubscriptionConstant'
import { TSG_NONE } from '../../../common/constants/GlobalConstants'

/**
 *   Validate the addons and license data for the subscription module.
 */

export const Validation = ({ ...params }) => {
  const tsg_id = params.selectedTreeNode ? params.selectedTreeNode.id : TSG_NONE.id
  const skipDomainValidation = getVarValue(FF_SKIP_DOMAIN_VALIDATION, false)
  const validators = ['maxValueValidation', 'minValueValidation', 'urlValidator']
  const { appId, maxCapacity, domainPostFix, cspAccount, editRules, checkBoxStatus, setErrorMessage } = params
  const validation = params.validationRules ?? {}
  const min_quantity = editRules?.min_quantity ?? (validation.min_quantity ? validation.min_quantity : 0)
  const max_quantity = editRules?.max_quantity ?? (validation.max_quantity ?? maxCapacity)
  const validationRequired = validation.validation_required
  return {
    validationFunction: (value) => {
      (setErrorMessage && typeof setErrorMessage === 'function') && setErrorMessage('')
      const errorList = []
      if (!URL_VALIDATIONS.includes(appId)) {
        if (value || value?.length === 0) {
          for (const validations of validators) {
            switch (validations) {
              case 'maxValueValidation': {
                //console.log('maxValueValidation(value, max_quantity)::::', appId, max_quantity, maxValueValidation(value, max_quantity))
                if (checkBoxStatus && !maxValueValidation(value, max_quantity)) {
                  errorList.push(`The maximum has to be ${max_quantity}`)
                }
                break
              }
              case 'minValueValidation': {
                //console.log('minValueValidation(value, max_quantity)::::', appId, min_quantity, minValueValidation(value, min_quantity))
                if (checkBoxStatus && !minValueValidation(value, min_quantity)) {
                  errorList.push(`The minimum value should be ${min_quantity}`)
                }
                break
              }
              default: {
                break
              }
            }
          }
        }
      }
      if (errorList.length) {
        //(setErrorMessage && typeof setErrorMessage === 'function') && setErrorMessage(errorList.join(','))
        return errorList.join(',')
      }
      return true
    },
    urlValidation: async (value) => {
      if (URL_VALIDATIONS.includes(appId) && validationRequired) {
        const regexExpression = URL_VALIDATIONS_REGEX[appId]
        if (value === '' || value?.trim().length === 0) {
          //(setErrorMessage && typeof setErrorMessage === 'function') && setErrorMessage('Please enter a valid url')
          return 'Please enter a valid url'
        }
        if (!regexExpression.test(value)) {
          //(setErrorMessage && typeof setErrorMessage === 'function') && setErrorMessage('Entered url is not valid')
          return 'Entered url is not valid'
        }
        else {
          const validationResponse = await urlValidator(value.toLowerCase(), tsg_id, appId, cspAccount, domainPostFix, skipDomainValidation)
          if (!validationResponse) {
            // (setErrorMessage && typeof setErrorMessage === 'function') && setErrorMessage('The url domain already in use')
            return 'The url domain already in use'
          }
          else {
            return true
          }
        }
      }
      return true
    }
  }
}


const maxValueValidation = (value, maxValue) => {
  return toNumber(value) <= toNumber(maxValue)
}
const minValueValidation = (value, minValue) => {
  return toNumber(value) >= toNumber(minValue)
}

const urlValidator = (requestDetails, tsg_id, app_id, cspAccount, domainPostFix, skipDomainValidation) => {
  return new Promise(async (resolve, reject) => {
    if (skipDomainValidation) {
      resolve(true)
    }
    else {
      const request = {
        'subdomain': requestDetails,
        'domainPostfix': domainPostFix[app_id]
      }
      const response = await ValidateSubDomainUrl(request, tsg_id, app_id)
      resolve(response === VALIDATION_SUCCESS)
    }
  })


}
